import type { Riddle } from './types';

export function approvedIdsToPublish(riddles: Pick<Riddle, 'id' | 'status'>[]): string[] {
  return riddles.filter((riddle) => riddle.status === 'approved').map((riddle) => riddle.id);
}
